import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter, Button, ModalHeader, Alert } from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay';
import axios from 'axios';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import ReactTooltip from 'react-tooltip';

class OutputParamsDialog extends Component {
	state = {
		outputParamsItem: null,
		outputParamsDialog: false,
		checkedOutputDefinedIds: [],
		checkedOutputUndefinedIds: [],
		isLoading: false,
		undefinedParamList: [],
		msg: {},
		newParamsList: [],
		isValidInputs: true
	};
	toggleMsgBox = () => {
		this.setState({
			msg: {}
		});
	};
	outputParamsStringToArray = (valueString) => {
		var _res = [];
		var _paramStrArray = valueString.split(',');
		_paramStrArray.forEach((item) => {
			var _paramItems = item.split(':');
			if (_paramItems.length > 0) {
				var _itemId = _paramItems[0].trim();
				_res.push({
					id: _paramItems[0],
					columnTitle: _paramItems[1] || '',
					description: _paramItems[2] || '',
					defined: _itemId.startsWith('@'),
					checked: true
				});
			}
		});
		return _res;
	};

	componentDidMount() {
		const { outputParamsValueStr, outputParamsItem: { paramsList } } = this.props;
		var _checkedList = outputParamsValueStr ? this.outputParamsStringToArray(outputParamsValueStr) : [];
		var _definedChecked = [];
		var _undefinedChecked = [];
		var _undefinedItemList = [];
		_checkedList.forEach((item) => {
			var _itemId = item['id'].trim();
			if (_itemId.startsWith('@')) {
				_definedChecked.push(_itemId.toLowerCase());
			} else {
				_undefinedItemList.push(item);
				_undefinedChecked.push(_itemId.toLowerCase());
			}
		});
		(paramsList || []).forEach((item) => {
			var _objIndex = _checkedList.findIndex((obj) => obj.id.toLowerCase() === item.id.toLowerCase());
			if (_objIndex === -1) {
				_checkedList.push({ ...item, defined: true });
			}
		});
		this.setState({
			allOutputParamItems: _checkedList,
			checkedOutputDefinedIds: _definedChecked,
			checkedOutputUndefinedIds: _undefinedChecked,
			undefinedParamList: _undefinedItemList
		});
	}

	onInputRowChange = (paramId, value) => {
		var _allOutputParamItems = (this.state.allOutputParamItems || []).slice(0);
		var objIndex = _allOutputParamItems.findIndex((obj) => obj.id.toLowerCase() === paramId.toLowerCase());
		if (objIndex > -1) {
			_allOutputParamItems[objIndex].columnTitle = value;
			this.setState({
				allOutputParamItems: _allOutputParamItems
			});
		}
	};

	getColumnTitleById = (paramId) => {
		let _items = (this.state.allOutputParamItems || [])
			.filter((item) => item.id.toLowerCase() === paramId.toLowerCase());
		return _items[0] && _items[0].columnTitle;
	};

	handleScanParamsClick = async () => {
		const { selectedCustomerId, selectedProjectId } = this.props;
		if (!selectedCustomerId) {
			this.setState({
				msg: {
					header: 'Scanning Params',
					message: (
						<Alert style={{ width: '650px' }} color="danger">
							No Selected Customer
						</Alert>
					)
				}
			});
			return;
		}
		try {
			this.setState({ isLoading: true });
			const { undefinedParamList, allOutputParamItems } = this.state;
			var params = {
				CustomerId: selectedCustomerId
			};
			if (!!selectedProjectId) {
				params['ProjectId'] = selectedProjectId;
			}
			var response = await axios.get('Reporting/getEventsParameters', {
				params: params
			});
			this.setState({ isLoading: false });
			if (response.data.Errors && response.data.Errors.length > 0) {
				this.setState({
					msg: {
						header: 'Scanning Params',
						message: (
							<Alert style={{ width: '650px' }} color="danger">
								{response.data.Errors[0]}
							</Alert>
						)
					}
				});
				return;
			}
			if (response.data.Data) {
				let _undefinedParamList = undefinedParamList.slice(0);
				let _allOutputParamItems = allOutputParamItems.slice(0);
				if (response.data.Data.length) {
					response.data.Data.forEach((item) => {
						var _objIndex = _undefinedParamList.findIndex(
							(obj) => obj.id.toLowerCase() === item.name.toLowerCase()
						);
						if (_objIndex === -1) {
							_undefinedParamList.push({
								id: item.name || '',
								columnTitle: item.name || '',
								description: `Example value: '${item.example}'` || ''
							});
							_allOutputParamItems.push({
								id: item.name || '',
								columnTitle: item.name || '',
								description: `Example value: '${item.example}'` || ''
							});
						}
					});
					this.setState({
						undefinedParamList: _undefinedParamList,
						allOutputParamItems: _allOutputParamItems
					});
				}
			}
		} catch (error) {
			this.setState({
				isLoading: false,
				msg: {
					header: 'Scanning Params',
					message: (
						<Alert style={{ width: '650px' }} color="danger">
							Server Error
						</Alert>
					)
				}
			});
		}
	};

	handleAddParamClick = () => {
		let _newParamsList = (this.state.newParamsList || []).slice(0);
		var _allOutputParamItems = (this.state.allOutputParamItems || []).slice(0);
		_newParamsList.push({
			checked: true,
			id: '',
			columnTitle: '',
			description: ''
		});
		_allOutputParamItems.push({
			checked: true,
			id: '',
			columnTitle: '',
			description: '',
			defined: false,
			isNew: true
		});

		this.setState({
			allOutputParamItems: _allOutputParamItems,
			newParamsList: _newParamsList,
			isValidInputs: false
		});
		setTimeout(() => {
			var _input = newInputRefs[_newParamsList.length - 1];
			_input && _input.focus();
		}, 700);
	};

	updateInputValidations = (checkedIds) => {
		const { undefinedParamList, allOutputParamItems, checkedOutputUndefinedIds } = this.state;
		var atLeastOneParamNameIsEmpty = false;

		if (atLeastOneParamNameIsEmpty === false) {
			(undefinedParamList || []).forEach((item) => {
				if ((checkedIds || checkedOutputUndefinedIds).includes(item.id.toLowerCase())) {
					var objIndex = allOutputParamItems.findIndex(
						(obj) => obj.id.toLowerCase() === item.id.toLowerCase()
					);
					if (objIndex > -1) {
						if (allOutputParamItems[objIndex].hasOwnProperty('paramTitle')) {
							if (!allOutputParamItems[objIndex].paramTitle) {
								atLeastOneParamNameIsEmpty = true;
							}
						}
					}
				}
			});
		}

		this.setState({
			isValidInputs: !atLeastOneParamNameIsEmpty
		});
	};

	hasDoubleParams = (outputParamsCheckedItems, checkedOutputDefinedIds, checkedOutputUndefinedIds, newParamsList) => {
		var _allParamsName = [];
		var _foundDouble = false;
		(checkedOutputDefinedIds || []).forEach((item) => {
			var _obj = (outputParamsCheckedItems || []).find((obj) => obj.id.toLowerCase() === item.toLowerCase());
			if (_obj) {
				_allParamsName.push(_obj.id.toLowerCase());
			}
		});
		(checkedOutputUndefinedIds || []).forEach((item) => {
			var _obj = (outputParamsCheckedItems || []).find((obj) => obj.id.toLowerCase() === item.toLowerCase());
			if (_obj) {
				if (_allParamsName.includes((_obj.paramTitle || _obj.id || '').toLowerCase())) {
					_foundDouble = true;
				} else {
					_allParamsName.push((_obj.paramTitle || _obj.id || '').toLowerCase());
				}
			}
		});
		if (_foundDouble) return true;

		(newParamsList || []).forEach((item) => {
			if (item.checked && item.id) {
				if (_allParamsName.includes((item.id || '').toLowerCase())) {
					_foundDouble = true;
				} else {
					_allParamsName.push((item.id || '').toLowerCase());
				}
			}
		});
		return _foundDouble;
	};

	moveRow = (dragIndex, hoverIndex) => {
		const { allOutputParamItems } = this.state;
		const dragRecord = allOutputParamItems[dragIndex];
		this.setState({
			allOutputParamItems: update(allOutputParamItems, {
				$splice: [ [ dragIndex, 1 ], [ hoverIndex, 0, dragRecord ] ]
			})
		});
	};

	setCheckedOutputDefinedIds = (checkedOutputDefinedIds) => this.setState({ checkedOutputDefinedIds });

	setCheckedOutputUndefinedIds = (checkedOutputUndefinedIds) => this.setState({ checkedOutputUndefinedIds });
	setAllOutputParamItems = (allOutputParamItems) => this.setState({ allOutputParamItems });

	render() {
		const { outputParamsDialog, toggleOutputParamsDialog, onOutputParamsDialogSubmit, translate } = this.props;

		const {
			checkedOutputDefinedIds,
			checkedOutputUndefinedIds,
			allOutputParamItems,
			newParamsList,
			isLoading
		} = this.state;

		const el = document.getElementById('drag-drop-output-params');

		return (
			<Modal isOpen={!!outputParamsDialog} style={{ maxWidth: '700px', maxHeight: '700px' }}>
				<LoadingOverlay active={isLoading} spinner text="Loading params...">
					<ModalBody style={{ maxHeight: 'calc(100vh - 140px)', overflowY: 'auto' }}>
						<div className="grid-container-config output-params-dialog">
							<table>
								<thead>
									<tr>
										<td className="grid-item wiz-table-header" style={{ width: '35px' }} />
										<td
											className="grid-item wiz-table-header"
											style={{ minWidth: '278px', textAlign: 'left' }}
										>
											Parameter
										</td>
										<td
											className="grid-item wiz-table-header"
											style={{ minWidth: '125px', textAlign: 'left' }}
										>
											Column title
										</td>
										<td className="grid-item wiz-table-header" style={{ textAlign: 'left' }}>
											Description
										</td>
									</tr>
								</thead>
								<DndProvider backend={HTML5Backend} options={{ rootElement: el }}>
									<tbody>
										{allOutputParamItems &&
											allOutputParamItems.length > 0 &&
											allOutputParamItems.map((row, index) => (
												<Row
													key={index}
													index={index}
													row={row}
													moveRow={this.moveRow}
													translate={translate}
													allOutputParamItems={allOutputParamItems}
													checkedOutputDefinedIds={checkedOutputDefinedIds}
													checkedOutputUndefinedIds={checkedOutputUndefinedIds}
													setState={this.setState}
													setCheckedOutputDefinedIds={this.setCheckedOutputDefinedIds}
													setCheckedOutputUndefinedIds={this.setCheckedOutputUndefinedIds}
													setAllOutputParamItems={this.setAllOutputParamItems}
													getColumnTitleById={this.getColumnTitleById}
													onInputRowChange={this.onInputRowChange}
													updateInputValidations={this.updateInputValidations}
												/>
											))}
									</tbody>
								</DndProvider>
							</table>
							<button
								type="button"
								style={{ margin: '10px 0 0' }}
								className="btn btn-secondary btn-sm"
								onClick={this.handleAddParamClick}
							>
								Add parameter
							</button>
							<button
								type="button"
								style={{ margin: '10px 10px 0 10px' }}
								className="btn btn-secondary btn-sm"
								onClick={this.handleScanParamsClick}
							>
								Scan possible parameters
							</button>
							<button
								type="button"
								className="tooltip-btn"
								style={{ verticalAlign: 'middle', margin: '5px 0px 0px' }}
								data-tip
								data-place="bottom"
								data-type="info"
								data-effect="solid"
								data-for="scanParamsTip"
							>
								<i className="fa fa-question-circle" />
							</button>
							<ReactTooltip className="customeTheme" id="scanParamsTip">
								<div style={{ width: '500px', textAlign: 'justify' }}>
									<p>
										When you press button "Scan possible parameters" system queries first 100
										documents for chosen customer/project and creates list of all parameters that
										are in found documents. Description field displays first non empty value of this
										field. Field will appear if at least one of the documents contain it, so its not
										guaranteed that all of documents will contain this document - especially if this
										scan is done without specifying flow. Use report "Test" to see what will be
										generated.
									</p>
								</div>
							</ReactTooltip>
						</div>
					</ModalBody>
					<ModalFooter>
						{!this.state.isValidInputs && (
							<div
								className="alert alert-danger"
								style={{
									float: 'left',
									textAlign: 'left',
									width: '100%',
									marginBottom: 0,
									padding: '0.4rem 0.8rem'
								}}
							>
								One of checked parameter names are empty.
							</div>
						)}{' '}
						<button type="button" className="btn btn-secondary" onClick={toggleOutputParamsDialog}>
							Close
						</button>
						<Button
							color="primary"
							disabled={!this.state.isValidInputs}
							className="switchBtn"
							style={{ width: '100px' }}
							onClick={() => {
								if (
									!this.hasDoubleParams(
										allOutputParamItems,
										checkedOutputDefinedIds,
										checkedOutputUndefinedIds,
										newParamsList
									)
								) {
									onOutputParamsDialogSubmit(allOutputParamItems);
								} else {
									this.setState({
										msg: {
											header: 'Duplicated Params',
											message: (
												<Alert style={{ width: '650px' }} color="danger">
													At least one Parameter name is dublicated.
												</Alert>
											)
										}
									});
								}
							}}
						>
							Save
						</Button>
					</ModalFooter>
				</LoadingOverlay>
				<Modal
					isOpen={!!this.state.msg.message}
					style={{ maxWidth: '680px', maxHeight: '700px' }}
					toggle={this.toggleMsgBox}
				>
					{this.state.msg.header && (
						<ModalHeader toggle={this.toggleMsgBox}>{this.state.msg.header}</ModalHeader>
					)}
					<ModalBody>{this.state.msg.message}</ModalBody>
					<ModalFooter className="text-center">
						<Button
							color="primary"
							className="switchBtn"
							style={{ width: '100px' }}
							onClick={this.toggleMsgBox}
						>
							{translate('OK')}
						</Button>
					</ModalFooter>
				</Modal>
			</Modal>
		);
	}
}

const newInputRefs = {};
const DND_ITEM_TYPE = 'paramRow';

const Row = ({
	row,
	index,
	moveRow,
	allOutputParamItems,
	checkedOutputDefinedIds,
	checkedOutputUndefinedIds,
	translate,
	setCheckedOutputDefinedIds,
	setCheckedOutputUndefinedIds,
	setAllOutputParamItems,
	getColumnTitleById,
	onInputRowChange,
	updateInputValidations
}) => {
	const dropRef = React.useRef(null);
	const dragRef = React.useRef(null);

	const [ , drop ] = useDrop({
		accept: DND_ITEM_TYPE,
		hover(item, monitor) {
			if (!dropRef.current) {
				return;
			}
			const dragIndex = item.index;
			const hoverIndex = index;
			if (dragIndex === hoverIndex) {
				return;
			}
			const hoverBoundingRect = dropRef.current.getBoundingClientRect();
			const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
			const clientOffset = monitor.getClientOffset();
			const hoverClientY = clientOffset.y - hoverBoundingRect.top;
			if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
				return;
			}
			if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
				return;
			}
			moveRow(dragIndex, hoverIndex);
			item.index = hoverIndex;
		}
	});

	const [ { isDragging }, drag, preview ] = useDrag({
		item: { type: DND_ITEM_TYPE, index },
		collect: (monitor) => ({
			isDragging: monitor.isDragging()
		})
	});

	const opacity = isDragging ? 0 : 1;
	const inputRefs = {};

	preview(drop(dropRef));
	drag(dragRef);

	return row.defined ? (
		<tr key={index} ref={dropRef} style={{ opacity }}>
			<td ref={dragRef} className="grid-item param-value move-icon">
				<button
					type="button"
					className="tooltip-btn"
					style={{ verticalAlign: 'middle' }}
					data-tip
					data-place="right"
					data-type="info"
					data-effect="solid"
					data-for={`moveRow-${index}`}
				>
					<i className="fas fa-arrows-alt-v" />
				</button>
				<ReactTooltip className="customeTheme" id={`moveRow-${index}`}>
					{translate('ToReorderRowsMsg')}
				</ReactTooltip>
			</td>
			<td className="grid-item wiz-table-header3 column-span-2 wizard-checkbox" style={{ padding: '0.5em' }}>
				<input
					type="checkbox"
					id={`defined-param-${row.id}`}
					style={{ margin: 0 }}
					name={row.id.toLowerCase()}
					onChange={(e) => {
						const { name } = e.target;
						var _checkedIds = checkedOutputDefinedIds.slice(0);
						var index = _checkedIds.indexOf(name);
						if (index >= 0) {
							_checkedIds.splice(index, 1);
						} else {
							_checkedIds.push(name);
						}
						setCheckedOutputDefinedIds(_checkedIds);
						var _allOutputParamItems = [ ...allOutputParamItems ];
						const elementsIndex = _allOutputParamItems.findIndex(
							(element) => element.id.toLowerCase() === row.id.toLowerCase()
						);
						_allOutputParamItems[elementsIndex] = {
							..._allOutputParamItems[elementsIndex],
							checked: !_allOutputParamItems[elementsIndex].checked
						};
						setAllOutputParamItems(_allOutputParamItems);
						if (inputRefs[row.id]) {
							var _inputField = inputRefs[row.id];
							setTimeout(() => {
								_inputField.focus();
							}, 200);
						}
					}}
					checked={checkedOutputDefinedIds.includes(row.id.toLowerCase())}
				/>
				<label
					htmlFor={`defined-param-${row.id}`}
					style={{ marginTop: '3px', display: 'contents' }}
					className="form-check-label"
				>
					{row.id}
				</label>
			</td>
			<td className="grid-item param-value">
				<input
					type="text"
					ref={(input) => (inputRefs[row.id] = input)}
					name={row.id.toLowerCase()}
					placeholder="Column title"
					value={getColumnTitleById(row.id.toLowerCase())}
					disabled={!checkedOutputDefinedIds.includes(row.id.toLowerCase())}
					onChange={(e) => {
						const { name, value } = e.target;
						onInputRowChange(name, value);
					}}
				/>
			</td>
			<td className="grid-item desc-container">{row.description}</td>
		</tr>
	) : !row.isNew ? (
		<tr key={index} ref={dropRef} style={{ opacity }}>
			<td ref={dragRef} className="grid-item param-value move-icon">
				<button
					type="button"
					className="tooltip-btn"
					style={{ verticalAlign: 'middle' }}
					data-tip
					data-place="right"
					data-type="info"
					data-effect="solid"
					data-for={`moveRow-${index}`}
				>
					<i className="fas fa-arrows-alt-v" />
				</button>
				<ReactTooltip className="customeTheme" id={`moveRow-${index}`}>
					{translate('ToReorderRowsMsg')}
				</ReactTooltip>
			</td>
			<td className="grid-item wiz-table-header3 column-span-2 add-new-param" style={{ padding: 0 }}>
				<div style={{ display: 'flex', padding: 0 }}>
					<input
						type="checkbox"
						id={`undefined-param-${row.id}`}
						style={{ margin: 0 }}
						name={row.id.toLowerCase()}
						onChange={(e) => {
							const { name } = e.target;
							var _checkedIds = checkedOutputUndefinedIds.slice(0);
							var index = _checkedIds.indexOf(name);
							if (index >= 0) {
								_checkedIds.splice(index, 1);
							} else {
								_checkedIds.push(name);
							}
							setCheckedOutputUndefinedIds(_checkedIds);

							var _allOutputParamItems = [ ...allOutputParamItems ];
							const elementsIndex = _allOutputParamItems.findIndex(
								(element) => element.id.toLowerCase() === row.id.toLowerCase()
							);
							_allOutputParamItems[elementsIndex] = {
								..._allOutputParamItems[elementsIndex],
								checked: !_allOutputParamItems[elementsIndex].checked
							};
							setAllOutputParamItems(_allOutputParamItems);
							if (inputRefs[row.id]) {
								var _inputField = inputRefs[row.id];
								setTimeout(() => {
									_inputField.focus();
								}, 200);
							}
							updateInputValidations(_checkedIds);
						}}
						checked={checkedOutputUndefinedIds.includes(row.id.toLowerCase())}
					/>
					<label
						htmlFor={`undefined-param-${row.id}`}
						style={{ marginTop: '3px', display: 'contents' }}
						className="form-check-label"
					>
						{' '}
					</label>
					<input
						type="text"
						placeholder="Parameter name"
						style={{ height: '2em' }}
						value={((paramId) => {
							var _allOutputParamItems = (allOutputParamItems || []).slice(0);
							var objIndex = _allOutputParamItems.findIndex(
								(obj) => obj.id.toLowerCase() === paramId.toLowerCase()
							);
							if (objIndex > -1) {
								if (_allOutputParamItems[objIndex].hasOwnProperty('paramTitle')) {
									return _allOutputParamItems[objIndex].paramTitle || '';
								} else {
									return paramId;
								}
							}
							return paramId;
						})(row.id)}
						disabled={!checkedOutputUndefinedIds.includes(row.id.toLowerCase())}
						onChange={(e) => {
							const { value } = e.target;
							const paramId = row.id;
							var _allOutputParamItems = (allOutputParamItems || []).slice(0);
							var objIndex = _allOutputParamItems.findIndex(
								(obj) => obj.id.toLowerCase() === paramId.toLowerCase()
							);
							if (objIndex > -1) {
								_allOutputParamItems[objIndex].paramTitle = value;
								setAllOutputParamItems(_allOutputParamItems);
								updateInputValidations();
							}
						}}
					/>
				</div>
			</td>
			<td className="grid-item param-value">
				<input
					type="text"
					ref={(input) => (inputRefs[row.id] = input)}
					name={row.id.toLowerCase()}
					placeholder="Column title"
					value={getColumnTitleById(row.id.toLowerCase())}
					disabled={!checkedOutputUndefinedIds.includes(row.id.toLowerCase())}
					onChange={(e) => {
						const { name, value } = e.target;
						onInputRowChange(name, value);
					}}
				/>
			</td>
			<td className="grid-item desc-container">{row.description}</td>
		</tr>
	) : (
		<tr key={index} ref={dropRef} style={{ opacity }}>
			<td ref={dragRef} className="grid-item param-value move-icon">
				<button
					type="button"
					className="tooltip-btn"
					style={{ verticalAlign: 'middle' }}
					data-tip
					data-place="right"
					data-type="info"
					data-effect="solid"
					data-for={`moveRow-${index}`}
				>
					<i className="fas fa-arrows-alt-v" />
				</button>
				<ReactTooltip className="customeTheme" id={`moveRow-${index}`}>
					{translate('ToReorderRowsMsg')}
				</ReactTooltip>
			</td>
			<td className="grid-item wiz-table-header3 column-span-2 add-new-param" style={{ padding: 0 }}>
				<div style={{ display: 'flex', padding: 0 }}>
					<input
						type="checkbox"
						id={`new-item-${index}`}
						style={{ margin: 0 }}
						onChange={(e) => {
							var _allOutputParamItems = allOutputParamItems.slice(0);
							_allOutputParamItems[index].checked = e.target.checked;
							setAllOutputParamItems(_allOutputParamItems);
							setTimeout(() => {
								var _input = newInputRefs[index];
								_input && _input.focus();
							}, 700);
							updateInputValidations();
						}}
						checked={row.checked}
					/>
					<label
						htmlFor={`new-item-${index}`}
						style={{ marginTop: '3px', display: 'contents' }}
						className="form-check-label"
					>
						{' '}
					</label>
					<input
						type="text"
						ref={(input) => (newInputRefs[index] = input)}
						placeholder="Parameter name"
						style={{ height: '2em' }}
						value={row.id}
						disabled={!row.checked}
						onChange={(e) => {
							const { value } = e.target;
							var _allOutputParamItems = allOutputParamItems.slice(0);
							_allOutputParamItems[index].id = value;
							setAllOutputParamItems(_allOutputParamItems);
							updateInputValidations();
						}}
					/>
				</div>
			</td>
			<td className="grid-item param-value">
				<input
					type="text"
					placeholder="Column title"
					value={row.columnTitle}
					disabled={!row.checked}
					onChange={(e) => {
						const { value } = e.target;
						var _allOutputParamItems = allOutputParamItems.slice(0);
						_allOutputParamItems[index].columnTitle = value;
						setAllOutputParamItems(_allOutputParamItems);
					}}
				/>
			</td>
			<td className="grid-item desc-container">{row.description}</td>
		</tr>
	);
};

function mapStateToProps(state) {
	const { locale } = state;
	return {
		translate: getTranslate(locale)
	};
}

const connectedOutputParamsDialog = connect(mapStateToProps)(OutputParamsDialog);
export { connectedOutputParamsDialog as OutputParamsDialog };
